// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .custom-header {
        display: flex;
        align-items: center;
        padding: 0.5em;
      }

      .custom-header-label {
        flex: 1;
        height: 1em;
        font-weight: 500;
        text-align: center;
      }

      .custom-double-arrow .mat-icon {
        margin: -22%;
      }
    
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImN1c3RvbWhlYWRlci5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtNQUNNO1FBQ0UsYUFBYTtRQUNiLG1CQUFtQjtRQUNuQixjQUFjO01BQ2hCOztNQUVBO1FBQ0UsT0FBTztRQUNQLFdBQVc7UUFDWCxnQkFBZ0I7UUFDaEIsa0JBQWtCO01BQ3BCOztNQUVBO1FBQ0UsWUFBWTtNQUNkIiwiZmlsZSI6ImN1c3RvbWhlYWRlci5jb21wb25lbnQudHMiLCJzb3VyY2VzQ29udGVudCI6WyJcbiAgICAgIC5jdXN0b20taGVhZGVyIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAgcGFkZGluZzogMC41ZW07XG4gICAgICB9XG5cbiAgICAgIC5jdXN0b20taGVhZGVyLWxhYmVsIHtcbiAgICAgICAgZmxleDogMTtcbiAgICAgICAgaGVpZ2h0OiAxZW07XG4gICAgICAgIGZvbnQtd2VpZ2h0OiA1MDA7XG4gICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgIH1cblxuICAgICAgLmN1c3RvbS1kb3VibGUtYXJyb3cgLm1hdC1pY29uIHtcbiAgICAgICAgbWFyZ2luOiAtMjIlO1xuICAgICAgfVxuICAgICJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/verification/customheader.component.ts"],"names":[],"mappings":";MACM;QACE,aAAa;QACb,mBAAmB;QACnB,cAAc;MAChB;;MAEA;QACE,OAAO;QACP,WAAW;QACX,gBAAgB;QAChB,kBAAkB;MACpB;;MAEA;QACE,YAAY;MACd;;AAEN,o0BAAo0B","sourcesContent":["\n      .custom-header {\n        display: flex;\n        align-items: center;\n        padding: 0.5em;\n      }\n\n      .custom-header-label {\n        flex: 1;\n        height: 1em;\n        font-weight: 500;\n        text-align: center;\n      }\n\n      .custom-double-arrow .mat-icon {\n        margin: -22%;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
